/// <reference path="../../libs.ts" />
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateSuspendedSubscriptionSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateSuspendedSubscriptionSettingRequest extends Request<IUpdateSuspendedSubscriptionSettingParams, IResult> {
  constructor(params: IUpdateSuspendedSubscriptionSettingParams) {
    super('updateSuspendedSubscriptionNotificationSetting', params);
  }
}
